import React from 'react'

const FlexContainer = ({ children, containerClass = '' }) => {
  return <div className={`display-flex ${containerClass}`}>{children}</div>
}

export default FlexContainer
